import React, { memo, ReactElement, useEffect, useState } from 'react';
import ChatComponent from '../components/chat/ChatComponent';
import { resetNotificationDot } from '../util';
import { fetchUserAccountRemote } from '../util/UserAccount';
import { useAuthFetchFromRestAPI } from '../util/api';
import { ITherapist } from '../util/types';
import ErrorComponent from '../components/ErrorComponent';
import LoadingSpinner from '../components/LoadingSpinner';
import { useChat } from '../contexts/chat-context';

const ChatPageContainer = (): ReactElement => {
  const { authFetch } = useAuthFetchFromRestAPI();
  const { initConnection } = useChat();

  const [userData, setUserData] = useState<ITherapist | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    resetNotificationDot();
    void load();
  }, []);

  const load = async (): Promise<void> => {
    setLoading(true);
    try {
      const userData = await fetchUserAccountRemote(authFetch);
      setUserData(userData);
      await initConnection();
      setError(false);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  
  if (error) {
    return (
      <ErrorComponent
        callback={load}>
      </ErrorComponent>
    );
  }
  
  return (
    <div className="bg-white w-100 vh-100 d-flex flex-row">
      {loading ?
        <LoadingSpinner /> :
        <ChatComponent therapist={userData}></ChatComponent>
      }
    </div>
  );
};
export default memo(ChatPageContainer);
